// The Cedar actions this app authorises against, in flexinet-directory-avp-infra's
// FlexiNetDirectory namespace. Each name matches an actionId in that store's
// schema exactly: under STRICT validation an action the schema does not declare
// fails the whole batch, even for an admin.
//
// The five came with the Users module from flexinet-console-app (FNP-2015).
// Add an action here and to the store's config/index.ts together.
export enum rbacActions {
    ListUsers = 'ListUsers',
    GetUser = 'GetUser',
    CreateUser = 'CreateUser',
    UpdateUser = 'UpdateUser',
    DeleteUser = 'DeleteUser',
}

export const actions = Object.values(rbacActions) as string[];
